import { Koi } from '@ksyos/koi';

export const alcoholEenhedenPerWeekSchema = Koi.number().min(0).max(50).precision(2);
export const alcoholDagenPerWeekSchema = Koi.number().min(0).max(7).precision(2);
export const alcoholGlazenPerDagSchema = Koi.number().min(0).max(50).precision(2);
export const bloeddrukDiastolischSchema = Koi.number().min(50).max(150);
export const bloeddrukSystolischSchema = Koi.number().min(80).max(200);
export const buikomvangSchema = Koi.number().min(30).max(500);
export const gewichtInKgSchema = Koi.number().min(0).max(750).precision(2);
export const hba1cSchema = Koi.number().min(0).max(150).precision(2);
export const hdlCholesterolSchema = Koi.number().min(0.01).max(10000).precision(2);
export const lengteInCmSchema = Koi.number().min(0).max(300);
export const ldlCholesterolSchema = Koi.number().min(0.01).max(10000).precision(2);
export const ontlastingFrequentiePerDagSchema = Koi.number().min(0).max(10).precision(2);
export const ontlastingFrequentiePerWeekSchema = Koi.number().min(0).max(70);
export const packYearsSchema = Koi.number().min(0).max(100).precision(2);
export const polsInBpmSchema = Koi.number().min(30).max(160);
export const triglyceridenSchema = Koi.number().min(0).max(10000).precision(2);
export const smokingPacksADaySchema = Koi.number().min(0).precision(2);
export const smokingYearsSchema = Koi.number().min(0).precision(2);
